// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"332":"d0a993dc","418":"84d428ad"}[chunkId] + ".js";
};